import React, { Fragment } from 'react'
import NProgress from 'react-nprogress'

import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'
import ListLoader from 'Pods/Shared/ListLoader'
import Loader from 'Pods/Shared/Loader'

import ProductAnalyticsSortableTh from './ProductAnalyticsSortableTh'
import modelImprovementsTooltipContent from './Tooltips/modelImprovementsTooltipContent'

export default class ProductAnalyticsModelImprovements extends React.Component {
  constructor() {
    super()

    this.state = {
      products: {
        data: [],
        meta: {
          didFetch: false,
          sortBy: ['publishing_score', 'asc'],
        },
      },
      list: [],
      initialFetch: true,
      reloadFetch: false,
      searchTerm: '',
      axiosSource: axios.CancelToken.source(),
      isFittingContainer: false,
    }

    this.tableWrapper = React.createRef()
    this.stickyHeader = React.createRef()
    this.stickyBody = React.createRef()
    this.stickyColumn = React.createRef()
    this.actualTableBody = React.createRef()

    this.onFetchProductsSuccess = this.onFetchProductsSuccess.bind(this)
    this.handleSortByChange = this.handleSortByChange.bind(this)
    this.formattedPublishingScore = this.formattedPublishingScore.bind(this)
    this.onProductEditButtonClick = this.onProductEditButtonClick.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.handleHeaderPosition = this.handleHeaderPosition.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    this.fetchProducts()
    this.handleHeaderPosition()
  }

  componentWillUnmount() {
    this.state.axiosSource.cancel('Component Is Unmounting')
    window.removeEventListener('resize', this.handleResize)
  }

  handleHeaderPosition() {
    if (this.stickyHeader.current && this.stickyBody.current && this.stickyColumn.current) {
      this.stickyHeader.current.style.left = `${this.stickyBody.current.scrollLeft * -1}px`
      this.stickyColumn.current.style.top = `${this.stickyBody.current.scrollTop * -1}px`
    }
  }

  handleResize() {
    if ((this.tableWrapper.current) && (this.actualTableBody.current)) {
      if (this.tableWrapper.current.clientWidth < this.actualTableBody.current.clientWidth || this.state.products.meta.totalCount == 0) {
        this.setState({ isFittingContainer: false })
      } else {
        this.setState({ isFittingContainer: true })
      }
    }

    this.handleHeaderPosition()
  }

  onTooltipShow(eventLabel) {
    dataLayer.push({
      event: 'CustomEvent',
      eventCategory: 'Seller analytics',
      eventAction: 'Model improvements tab',
      eventLabel,
    })
  }

  onProductEditButtonClick() {
    dataLayer.push({
      event: 'CustomEvent',
      eventCategory: 'Seller analytics',
      eventAction: 'Model improvements tab',
      eventLabel: 'Edit button',
    })
  }

  fetchProducts(filterData = { page: 1, sort_by: ['publishing_score', 'asc'], term: [] }) {
    NProgress.start()

    return axios.get('/api/internal/product-analytics', {
      params: filterData,
      cancelToken: this.state.axiosSource.token,
    }).then(this.onFetchProductsSuccess)
      .catch((error) => {})
  }

  onFetchProductsSuccess(response) {
    NProgress.done()

    if (this.state.initialFetch && response.data.meta.totalCount !== 0) {
      this.setState({ initialFetch: false })
    }

    setTimeout(() => {
      this.handleResize()
    }, 20)

    return this.setState(prevState => ({
      products: response.data,
      list: this.state.reloadFetch ? response.data.data : prevState.list.concat(response.data.data),
    }))
  }

  handleSortByChange(attribute, direction) {
    this.setState({ reloadFetch: true })
    this.fetchProducts({ page: 1, sort_by: [attribute, direction], term: [this.state.searchTerm] })
  }

  handleInputChange(event) {
    this.setState({
      searchTerm: event.target.value,
    })
  }

  handleSearch(event) {
    event.preventDefault()
    this.setState({ reloadFetch: true })
    return this.fetchProducts({ page: 1, sort_by: this.state.products.meta.sortBy, term: [this.state.searchTerm] })
  }

  sortableThDirection(attribute) {
    return this.state.products.meta.sortBy[0] == attribute && this.state.products.meta.sortBy[1]
  }

  productColumnClassName(product, column) {
    if (product.attributes.needsImprovement.includes(column)) {
      return 'u-text-center requires-attention'
    }
    return 'u-text-center'
  }

  formattedPublishingScore(publishingScore) {
    if (publishingScore != 10) {
      return numeral(publishingScore).format('0.0')
    }
    return numeral(publishingScore).format('0')
  }

  handlePageChange(pageNumber) {
    this.setState({ reloadFetch: false })
    return this.fetchProducts({ page: pageNumber, sort_by: this.state.products.meta.sortBy, term: [this.state.searchTerm] })
  }

  renderTableBody() {
    return (
      <Fragment>
        {this.state.products.meta.totalCount == 0 ? (
          <tbody>
            <tr className="table-row--5x">
              <td colSpan="6">
                <div className="empty-content-small u-text-center">
                  <p>
                    Sorry, no models found.
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {this.state.list.map((product, index) => (
              <tr className="table-row--2x" key={product.id}>
                <td className="model-title">
                  <a href={product.attributes.url} target="_blank">
                    <div className="responsive-table__content">
                      {product.attributes.title}
                    </div>
                  </a>
                </td>
                <td className={this.productColumnClassName(product, 'total_images')}>
                  {product.attributes.totalImages}
                </td>
                <td className={this.productColumnClassName(product, 'total_uniq_file_types')}>
                  {product.attributes.totalUniqFileTypes}
                </td>
                <td className={this.productColumnClassName(product, 'total_description_words')}>
                  {product.attributes.totalDescriptionWords}
                </td>
                <td className={this.productColumnClassName(product, 'total_tags')}>
                  {product.attributes.totalTags}
                </td>
                <td className={this.productColumnClassName(product, 'publishing_score')}>
                  {this.formattedPublishingScore(product.attributes.publishingScore)}
                  <a
                    href={`/profile/models/${product.id}/edit`}
                    className="btn btn-primary btn-sm btn-hide u-ml10"
                    target="_blank"
                    onClick={this.onProductEditButtonClick}
                  >
                    Edit
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </Fragment>
    )
  }

  renderLoader() {
    return (
      <div className="card-flat">
        <Loader />
      </div>
    )
  }

  renderEmptyTable() {
    return (
      <div className="card-flat">
        <div className="empty-content u-text-center">
          <p>
            Sorry, you haven't published any models yet!
          </p>
        </div>
      </div>
    )
  }

  render() {
    if (this.state.products.meta.didFetch == false) {
      return (
        this.renderLoader()
      )
    } if (this.state.initialFetch) {
      return (
        this.renderEmptyTable()
      )
    }
    return (
      <div className="card card--flat">
        <div className="l-inner">
          <h2 className="content-heading__h2">
            Models to Improve
            <Tooltip
              tooltipClassName="tooltip--big tooltip--spaced"
              id="top-keywords--tooltip"
              html
              content={modelImprovementsTooltipContent}
            >
              <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
            </Tooltip>
          </h2>
          <div ref={this.tableWrapper} className="table-responsive__wrapper">
            <div className="table-responsive table-responsive--default table-responsive--sticky-top analytics-table analytics-table--model-improvements">
              <table ref={this.stickyHeader} className={`analytics-table table-responsive__sticky-header ${!this.state.isFittingContainer ? '' : 'analytics-table__header-fits'}`}>
                <thead>
                  <tr className="table-row--3x">
                      <th className="u-text-left">
                        <div className="search-bar">
                          <span className="search-bar__title">Title</span>
                          <div className="search-bar__form-wrap">
                            <form className="search-bar__form" onSubmit={this.handleSearch}>
                              <input type="text" placeholder="Search by name" value={this.state.searchTerm} className="form-control form-control-sm" onChange={this.handleInputChange} />
                              <button type="submit" className="btn btn-transparent btn-sm">
                                <Icon type="search" color="green-dark" className="info-icon" notSpaced />
                              </button>
                            </form>
                          </div>
                        </div>
                      </th>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="total_images"
                        direction={this.sortableThDirection('total_images')}
                        onSortByChange={this.handleSortByChange}
                        defaultSortingAsc
                      >
                        Images
                        <Tooltip
                          tooltipClassName="tooltip--medium"
                          id="images"
                          content={I18n.translate('tooltips.product_analytics.images_html')}
                          onShow={() => this.onTooltipShow('Images')}
                        >
                          <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
                        </Tooltip>
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="total_uniq_file_types"
                        direction={this.sortableThDirection('total_uniq_file_types')}
                        onSortByChange={this.handleSortByChange}
                        defaultSortingAsc
                      >
                        Formats
                        <Tooltip
                          tooltipClassName="tooltip--medium"
                          id="formats"
                          content={I18n.translate('tooltips.product_analytics.formats_html')}
                          onShow={() => this.onTooltipShow('Formats')}
                        >
                          <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
                        </Tooltip>
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="total_description_words"
                        direction={this.sortableThDirection('total_description_words')}
                        onSortByChange={this.handleSortByChange}
                        defaultSortingAsc
                      >
                        Description words
                        <Tooltip
                          tooltipClassName="tooltip--medium"
                          id="description"
                          content={I18n.translate('tooltips.product_analytics.description_html')}
                          onShow={() => this.onTooltipShow('Description')}
                        >
                          <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
                        </Tooltip>
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="total_tags"
                        direction={this.sortableThDirection('total_tags')}
                        onSortByChange={this.handleSortByChange}
                        defaultSortingAsc
                      >
                        Tags
                        <Tooltip
                          tooltipClassName="tooltip--medium"
                          id="tags"
                          content={I18n.translate('tooltips.product_analytics.tags_html')}
                          onShow={() => this.onTooltipShow('Tags')}
                        >
                          <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
                        </Tooltip>
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="publishing_score"
                        direction={this.sortableThDirection('publishing_score')}
                        onSortByChange={this.handleSortByChange}
                        defaultSortingAsc
                      >
                        Model Score
                        <Tooltip
                          tooltipClassName="tooltip--medium"
                          id="modelScore"
                          content={I18n.translate('tooltips.product_analytics.models_score_html')}
                          onShow={() => this.onTooltipShow('Publishing score')}
                        >
                          <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
                        </Tooltip>
                      </ProductAnalyticsSortableTh>
                    </tr>
                </thead>
              </table>
              <div className={`table-responsive__table-body ${!this.state.isFittingContainer && this.state.products.meta.totalCount > 0 ? 'table-responsive--sticky-left' : ''}`} ref={this.stickyBody} onScroll={this.handleHeaderPosition}>
                {!this.state.isFittingContainer && this.state.products.meta.totalCount > 0 && (
                <div className="analytics-table-wrapper">
                      <div className="table-responsive--sticky-left table-responsive__clone" ref={this.stickyColumn}>
                        <table className="analytics-table analytics-table--model-improvements">
                          {this.renderTableBody()}
                        </table>
                      </div>
                    </div>
                )}
                <table ref={this.actualTableBody} className="analytics-table analytics-table--model-improvements">
                  {this.renderTableBody()}
                </table>
              </div>
            </div>
          </div>
          <ListLoader
            totalPages={this.state.products.meta.total_pages}
            currentPage={this.state.products.meta.current_page}
            onShowMore={this.handlePageChange}
            buttonClass="btn btn-transparent btn-block btn-show-more__small-margins"
          />
        </div>
      </div>
    )
  }
}
